import { Box, Button, CloseButton, Dialog, Menu, Portal, useDisclosure } from '@chakra-ui/react';
import { FC, ReactNode, useMemo, useRef, useState } from 'react';
import { CiSettings } from 'react-icons/ci';
import type { MediaDevice } from '../video/video-types';
import { LocalVideoTrack } from '@zoom/videosdk';
import useLanguageSelector from '../../hooks/useLanguageSelector';
type Props = {
  // mediaSettingChildren: ReactNode;
  onDisplayMediaSetting: (value: boolean) => void;
};
const SettingsButton: FC<Props> = ({ onDisplayMediaSetting }) => {
  const LANG = useLanguageSelector();
  const adialogTriggerProps: Dialog.TriggerProps = { asChild: true };
  const menuTriggerProps: Menu.TriggerProps = { asChild: true };
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  return (
    <>
      <Menu.Root closeOnSelect={true}>
        <Menu.Trigger {...menuTriggerProps}>
          <Button background={'#fff'}>
            <CiSettings /> {LANG.KT_0100_28}
          </Button>
        </Menu.Trigger>
        <Portal>
          <Menu.Positioner>
            <Menu.Content>
              <Menu.Item>
                <Box
                  cursor={'pointer'}
                  _hover={{ bg: '#DDD' }}
                  onClick={async () => {
                    onDisplayMediaSetting(true);
                  }}
                  width={'100%'}
                >
                  {LANG.KT_0100_06}
                </Box>
              </Menu.Item>
            </Menu.Content>
          </Menu.Positioner>
        </Portal>
      </Menu.Root>
    </>
  );
};
export default SettingsButton;
